<div mat-dialog-title
     class="title">

  <button mat-icon-button
          mat-dialog-close
          tabindex="-1"
          [matTooltip]="'Close' | translate"
          class="close-button hidden">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <sessions-session-view *ngIf="!isLoading" [organization]="organization"
                         [session]="session"
                         [isAllCollapsed]="false"
                         [hideGeneralPanel]="true"
                         [showLeftPanel]="false"
                         [sessionId]="sessionRow!.id!"
  >

  </sessions-session-view>
</mat-dialog-content>
<mat-dialog-actions>
<!--  app actions-->
  <div class="actions">
    <button mat-button
            mat-dialog-close
            color="primary">
      {{ 'Close' | translate}}
    </button>
    <button *ngIf="sessionRow && sessionRow.rights?.edit && timeslot"
            mat-raised-button
            mat-dialog-close
            color="accent"
            [disabled]="sessionDateNotOverdue() || timeslot.id === undefined"
            (click)="onFeedbackNewClicked()"
            class="small-button">
      {{ 'SessionEndSmall' | translate}}
    </button>
    <button *ngIf="sessionRow && sessionRow.rights?.terminate && timeslot"
            mat-raised-button
            mat-dialog-close
            color="accent"
            [disabled]="sessionDateNotOverdue() || timeslot.id === undefined"
            (click)="onFeedbackNewClicked()"
            class="large-button">
      {{ 'SessionEnd' | translate}}
    </button>
    <button *ngIf="sessionRow && sessionRow.rights?.edit && isEditable"
            mat-raised-button
            mat-dialog-close
            color="accent"
            (click)="onEditClicked()">
      {{ 'Edit' | translate}}
    </button>
  </div>
</mat-dialog-actions>
